export default "/images/vendor/flag-icon-css/flags/1x1/vi.svg?1ae3b627580608e32c9947b9a2a87144";